<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div>
              <h2>Clash Meta for Android客户端使用教程</h2>
              <p><strong>关于耗电</strong></p>
              <p>
                代理软件会接管几乎全局网络通信，所以所有网络方面的电量消耗都会被算在代理软件上，实际上代理软件的运行功耗很少，使用中也不会感到软件对电量有明显影响。
              </p>
              <h3>一.下载最新版(2.10.0, 2024年1月19日更新)</h3>
              <ul>
                <li>
                  <a href="https://www.91freedom.live/img/client/android/cmfa/cmfa-2.10.1-meta-arm64-v8a-release.apk">点我下载</a>
                </li>
                <li>
                  <a
                    href="https://mirror.ghproxy.com/https://github.com/MetaCubeX/ClashMetaForAndroid/releases/download/v2.10.0/cmfa-2.10.0-meta-arm64-v8a-release.apk"
                    >备用下载1</a
                  >
                </li>
                <li>
                  <a
                    href="https://github.com/MetaCubeX/ClashMetaForAndroid/releases/download/v2.10.0/cmfa-2.10.0-meta-arm64-v8a-release.apk"
                    >备用下载2</a
                  >
                </li>
                <li>
                  <a href="https://wwst.lanzout.com/ix6971ljppvi"
                    >备用下载(蓝奏云)</a
                  >密码:41d6
                </li>
              </ul>
              <hr />
              <!-- <h5>
                2.在手机浏览器中打开本站（推荐使用Chrome、Edge、Firefox等浏览器，国产浏览器有可能拦截本站）
              </h5> -->
              <div class="display-4 mt-4 mb-4">订阅信息</div>
              <!-- <hr />
              <h5>3.在网站后台选择“仪表板”或“我的订阅”：</h5>
              <img src="/img/client/android/cmfa/ametap.webp" width="350" /> -->
              <!-- <hr /> -->
              <div v-if="accounts.length">
                <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                  <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                  <a
                    :href="`clash://install-config?url=${subLinks_1}/v1/api/clash/${account.subscription || account._id }?flag=clashmeta&?name=${account.product.title}`"
                    class="btn btn-primary btn-sm mb-2"><i class="fa fa-share"/> 点我导入到 Clash Meta</a
                    >
                  <!-- <code>{{ `${subLinks_1}/v1/api/clash/${account.subscription || account._id }` }}</code> -->
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/clash/${account.subscription || account._id }?name=${account.product.title}`, $event)" >复制订阅地址1</base-button>
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/clash/${account.subscription || account._id }?name=${account.product.title}`, $event)" >复制订阅地址2</base-button>
                </div>
                <!-- 例子 v2rayng://install-config?url=http%3A%2F%2Fexample.com&name=example
  v2rayng://install-config?url 是固定，url=后面是订阅地址 -->
              </div>
              <div class="display-4 mt-4 mb-4">图文教程：</div>
              <h5 class="display-6 mt-2 mb-2">1.确保手机中已下载安装Clash Meta for Android。</h5>
              <h5 class="display-6 mt-2 mb-2">2.点击上面按钮“点我导入到 Clash Meta“</h5>
              
              <!-- <img src="/img/client/android/cmfa/ametap2.webp" width="350" /> -->
              <p>
                <strong
                  ><font color="red"
                    >注意：如果点击导入Clash不生效，可以使用手动粘贴订阅地址的方式：</font
                  ><br />
                  点击上面👆订阅信息 “复制订阅地址”，打开Clash，点“配置” -&gt;
                  右上角“+”号 -&gt; “URL” -&gt; 点“URL” -&gt; 粘贴、确认 -&gt;
                  点右上角“保存”图标。</strong
                >
              </p>
              <hr />
              <h5>
                3.正常情况下会弹出Clash客户端界面，点击右上角下载配置和设置自动更新时间：
              </h5>
              <img src="/img/client/android/cmfa/ameta1.webp" width="350" />
              <hr />
              <h5>4.下载成功后自动跳转配置选择界面，选择当前配置：</h5>
              <img src="/img/client/android/cmfa/ameta3.webp" width="350" />
              <hr />
              <h5>5.返回主界面点击“启动”：</h5>
              <img src="/img/client/android/cmfa/ameta4.webp" width="350" />
              <hr >
              <h5>
                6.在节点选择页面切换不同节点和切换代理模式：(建议选择“自动最优”线路）
              </h5>
              <img src="/img/client/android/cmfa/ameta5.webp" width="350" >
              <hr >
              <h5>
                7.弹窗授权网络连接，点击 “确定”
              </h5>
              <img src="/img/client/android/cmfa/ameta6.webp" width="350" >
              <hr />

              <!-- <h3>视频教程：</h3>
              <h4>1.下载并安装Clash：</h4>
              <p>
                <video
                  src="../static/dghelpvideo/a1.mp4"
                  controls="controls"
                  width="250"
                ></video>
              </p>
              <h4>2.订阅导入Clash使用：</h4>
              <p>
                <video
                  src="../static/dghelpvideo/a2.mp4"
                  controls="controls"
                  width="250"
                ></video>
              </p> -->
              <!-- <p>
                <strong
                  >注意：如果点击导入Clash不生效，可以使用手动粘贴订阅地址的方式：<br />
                  面板点击“复制订阅地址”，打开Clash，点“配置”-&gt;右上角“+”号-&gt;“URL”-&gt;点“URL”-&gt;粘贴确认-&gt;点击右上角“保存”图标。</strong
                >
              </p> -->
            </div>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }
}
</script>
<style scoped>
.product-title {
  width: 120px;
  display: inline-block;
}
/* .sub-item{

} */
.search-noresults img {
  max-width: 100%;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 400px;
  }
}
</style>
